<template>
  <div class="className" />
</template>

<script>
import echarts from 'echarts' // echarts theme
import { debounce } from '@/utils/util'
require('echarts/theme/macarons')
export default {
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    name: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      },
    },
  },
  mounted() {
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 600)
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions({ name, orderCount } = {}) {
      this.chart.setOption({
        // title: {
        //   text: '自定义水平柱状图',
        // },
        grid: {
          left: '50px', // 去掉左边距
          right: '0%', // 去掉右边距
          top: '10px', // 根据需要设置顶部边距
          bottom: '20px', // 根据需要设置底部边距
          show: false,
        },
        tooltip: {},
        xAxis: {
          type: 'value',
          splitArea: {
            show: false, // 去除网格的背景色
          },
          axisLine: {
            show: false, // 不显示 y 轴线
          },
          // axisLabel: {
          //   color: '#ffffff', // 设置 Y 轴文字颜色为橙色
          // },
          // axisTick: {
          //   show: false, // 去掉Y轴刻度线
          // },
          splitLine: {
            show: false, // 禁用 y 轴的网格线
          },
          axisLabel: {
            formatter: '{value} ', // 格式化 x 轴标签
          },
        },
        yAxis: {
          type: 'category',
          splitArea: {
            show: false, // 去除网格的背景色
          },
          splitLine: {
            show: false, // 禁用 y 轴的网格线
          },
          // axisTick: {
          //   show: false, // 去掉Y轴刻度线
          // },
          axisLine: {
            show: false, // 不显示 y 轴线
          },
          axisLabel: {
            show: true, // 不显示 y 轴线
            color: '#ffffff', // 设置 Y 轴文字颜色为橙色
          },
          data: name,
        },
        series: [
          {
            type: 'bar',
            data: orderCount,
            name: '水工单数',
            barWidth: '10px', // 设置宽度为类目宽度的50%
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                1,
                0, // 这四个参数分别表示渐变的起点 (x1, y1) 与终点 (x2, y2)
                [
                  { offset: 0, color: '#033b8d' }, // 0% 处的颜色
                  { offset: 1, color: '#37ffb8' }, // 100% 处的颜色
                ]
              ),
            },
          },
        ],
      })
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
  },
}
</script>
<style less scoped>
.className {
  width: 100%;
  height: 20vh;
  /* height: 470px; */
}
</style>
